<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'RichTextRender',
})
</script>
<template>
  <iframe ref="iframeRef" :class="bem()" :srcdoc="richContent" frameborder="0" @load="adjustIframeHeight" />
</template>

<script lang="ts" setup name="RichTextRender">
import { createNamespace } from '@bd/vue3-utils'
import { computed, nextTick, ref, watch } from 'vue'

const props = defineProps<{
  content?: string
}>()
const [_, bem] = createNamespace('RichTextRender')

const richContent = computed(
  () => `
  <link rel="stylesheet" href="/rich/style.css" />
  ${props.content}
`
)
const iframeRef = ref<HTMLIFrameElement>()
const adjustIframeHeight = () => {
  nextTick(() => {
    if (iframeRef.value?.contentWindow) {
      try {
        const iframeDocument = iframeRef.value.contentWindow.document
        const height = iframeDocument.documentElement.scrollHeight || iframeDocument.body.scrollHeight
        if (height > 0) {
          iframeRef.value.style.height = `${height}px`
        }
      } catch (e) {
        console.warn('无法访问iframe内容:', e)
      }
    }
  })
}

// 监听内容变化，重新调整高度
watch(
  () => props.content,
  () => {
    nextTick(() => {
      adjustIframeHeight()
    })
  }
)
</script>

<style lang="less">
.rich-text-render {
  width: 100%;
  min-height: 200px;
  border: none;
}
</style>
